import { useQuery } from '@tanstack/react-query';

import { api } from '../../core/network/api';
import { raceKeys, racePaths } from '../queries/races';

// TSS vite/03 — catálogo de razas del canal público (public-races.md, Q-124).
// Read-only, catálogo chico sin paginación: { items: [{ id, name, code }] }
// envuelto en el sobre público (view "races") → el caller lee con
// envelopeData(). Catálogo global (no scoped); cambia poco → staleTime largo.
export function useRaces({ q } = {}) {
    return useQuery({
        queryKey: raceKeys.list({ q }),
        queryFn: ({ signal }) =>
            api.get(racePaths.list(), { params: { q }, signal }).then((r) => r.data),
        staleTime: 10 * 60_000, // 10 min — catálogo, rara vez cambia
    });
}
